'use strict';

var _commonMain = require('./modules/common/commonMain');

var _commonMain2 = _interopRequireDefault(_commonMain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _commonMain2.default(); // 页面公用部分 比如顶部，底部